"use client";

import { CheckIcon, CopyIcon } from "lucide-react";
import { useState } from "react";

import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
  InputGroupText,
} from "@workspace/ui/components/input-group";

import { useCopyToClipboard } from "~/lib/hooks/use-copy-to-clipboard";

const COPY_TIMEOUT = 2000;

interface InstallerProps {
  readonly className?: string;
  readonly command: string;
}

export const Installer = ({ command, className = "w-48" }: InstallerProps) => {
  const [, copy] = useCopyToClipboard();
  const [showCheck, setShowCheck] = useState(false);

  const handleCopy = async () => {
    const success = await copy(command);
    if (!success) {
      return;
    }

    setShowCheck(true);
    setTimeout(() => {
      setShowCheck(false);
    }, COPY_TIMEOUT);
  };

  const Icon = showCheck ? CheckIcon : CopyIcon;

  return (
    <InputGroup className="bg-background h-10 w-fit rounded-xl px-2 font-mono md:h-11">
      <InputGroupAddon>
        <InputGroupText className="text-muted-foreground font-normal">
          $
        </InputGroupText>
      </InputGroupAddon>
      <InputGroupInput
        aria-label="Install command"
        className={className}
        readOnly
        value={command}
      />
      <InputGroupAddon align="inline-end">
        <InputGroupButton
          aria-label="Copy"
          onClick={() => void handleCopy()}
          size="icon-xs"
          title="Copy"
        >
          <Icon className="size-3.5" />
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
};
